import { DashValue } from 'src/modules/valves/ValveCard/DashValue.ts';
import { AttributesList } from 'src/utils/createAttributesItem.ts';
import {
    ActuatorsPageAmQuery,
    ActuatorsPageEuQuery,
} from 'src/generated/operations.ts';
import { filterEmpty } from 'src/utils/filterEmpty.ts';
import { AttributesAliases } from 'src/generated/dict.ts';

type Data = ActuatorsPageEuQuery['vssActuators']['products']['0']['product']
| ActuatorsPageAmQuery['vssActuators']['products']['0']['product'];

export function prepareActuatorAttributes(product: Data): [AttributesList, AttributesList] {
    let attrs: [AttributesList, AttributesList] = [
        [
            [AttributesAliases.nominalVoltage, product.nominalVoltage || DashValue],
            [AttributesAliases.controlType, product.controlType || DashValue],
            [AttributesAliases.runningTime, product.runningTime || DashValue],
            [AttributesAliases.failSafeFunction, product.failSafeFunction || DashValue],
        ], [
            [AttributesAliases.torque, product.torque],
            [AttributesAliases.actuatingForce, product.actuatingForce],
            [AttributesAliases.stroke, product.stroke],
            [AttributesAliases.protection, product.protection || DashValue],
            [AttributesAliases.integratedSwitch, product.integratedSwitch || DashValue],
        ]];
    if ('actuatingForceLbf' in product) {
        attrs = [
            [
                [AttributesAliases.nominalVoltage, product.nominalVoltage || DashValue],
                [AttributesAliases.controlType, product.controlType || DashValue],
                [AttributesAliases.runningTime, product.runningTime || DashValue],
                [AttributesAliases.failSafeFunction, product.failSafeFunction || DashValue],
            ], [
                [AttributesAliases.actuatingForce, product.actuatingForceLbf],
                [AttributesAliases.stroke, product.stroke],
                [AttributesAliases.protection, product.protection || DashValue],
                [AttributesAliases.integratedSwitch, product.integratedSwitch || DashValue],
            ]];
    }
    return [attrs[0].filter(filterEmpty), attrs[1].filter(filterEmpty)];
}
